import FuelSurcharge from "@/components/tradeterms/FuelSurcharge.vue";

export default {
  path: "/fuel-surcharge",
  name: "TradetermsFuel",
  component: FuelSurcharge,
  meta: {
    breadcrumb: "fuel-surcharge"
  }
};
